import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { EnvService } from 'src/app/services/env.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private env: EnvService) { }
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const userToken = sessionStorage.getItem('token');
    let url = req.url;
    let urlApi = this.env.URL_API_V1;
    if (req.url.indexOf(urlApi) != -1) {
      url = `${urlApi}/${Date.now()}${url.split(urlApi).pop()}`;
    }

    const modifiedReq = req.clone({
      url: url,
      headers: req.headers.set('access-token', `${userToken}`),
    });
    return next.handle(modifiedReq);
  }
}
